import { formatNumber } from '@angular/common';
import { LOCALE_ID, Pipe, PipeTransform, inject } from '@angular/core';

declare type Unit = [name: string, bytes: number];

// units in uppercase are the only correct form.´
// alternatives are:
// kB -> Metric not 1024 based but 1000 based
// KiB -> kibibyte -> 1024 based
// KB -> Legacy name of kilobyte 1024 based (used in Windows)
// https://en.wikipedia.org/wiki/Kilobyte
const byteUnits: Unit[] = [
  ['PB', Math.pow(1024, 5)],
  ['TB', Math.pow(1024, 4)],
  ['GB', 1 << 30],
  ['MB', 1 << 20],
  ['KB', 1 << 10],
  ['B',  1],
];
const fallbackByteUnit = byteUnits[byteUnits.length - 1];

@Pipe({
  name: 'bytes',
  standalone: true,
})
export class BytesPipe implements PipeTransform {

  private localeId = inject(LOCALE_ID);

  public transform(bytes: number): string {
    const positiveBytes = Math.abs(bytes);

    let unit = fallbackByteUnit;
    for (const currentUnit of byteUnits) {
      if (positiveBytes >= currentUnit[1]) {
        unit = currentUnit;
        break;
      }
    }

    const bytesInUnit = bytes / unit[1];
    return `${formatNumber(bytesInUnit, this.localeId, '1.0-1')} ${unit[0]}`;
  }

}
